module.exports = __webpack_public_path__ + "static/media/webdevelopment3.72134ca2.jpg";